import axios from 'axios';
import router from "@/main";
// Import your router to handle redirects

// Create an Axios instance
const apiClient = axios.create({
  baseURL: '/api/v1', // Base URL for your API
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add a request interceptor to include the access token in every request
apiClient.interceptors.request.use(
  config => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// Add a response interceptor to handle authentication errors
apiClient.interceptors.response.use(
  response => response,
  error => {
    if (error.response && (error.response.status === 401 )) {
      // Clear the auth token and redirect to the login page
      localStorage.removeItem('authToken');
      router.push('/login');
    }
    return Promise.reject(error);
  }
);

export default apiClient;
